import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ProfileContext = createContext({
  profiles: [],
  active: null,
  activeProfile: null,
  isSuper: false,
  loading: true,
  refetch: () => {},
});

const API = process.env.REACT_APP_BACKEND_URL;

export function ProfileProvider({ children }) {
  const [profiles, setProfiles] = useState([]);
  const [active, setActive] = useState(null);
  const [isSuper, setIsSuper] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchProfiles = useCallback(async () => {
    try {
      const r = await fetch(`${API}/api/profiles`, { credentials: 'include' });
      if (!r.ok) { setLoading(false); return; }
      const d = await r.json();
      setProfiles(d.profiles || []);
      setActive(d.active);
      setIsSuper(!!d.is_super_admin);
    } catch { /* ignore */ }
    setLoading(false);
  }, []);

  useEffect(() => { fetchProfiles(); }, [fetchProfiles]);

  const activeProfile = profiles.find(p => p.slug === active) || null;

  return (
    <ProfileContext.Provider value={{ profiles, active, activeProfile, isSuper, loading, refetch: fetchProfiles }}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfile() {
  return useContext(ProfileContext);
}
